var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4 {\n        fill: #637b93;\n      }\n\n      .cls-2, .cls-5 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-5 {\n        fill: none;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 80,
    cy: 80,
    r: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105,55l-50,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105,105L55,55"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 144.76,
    y1: 171.5,
    x2: 166.21,
    y2: 171.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241,171.5c0-13.13,10.64-23.77,23.77-23.77s23.77,10.64,23.77,23.77h13.02c7.86,0,14.23-6.37,14.23-14.23V60.44c0-7.86-6.37-14.23-14.23-14.23h-121.12c-7.86,0-14.23,6.37-14.23,14.23v111.06s74.79,0,74.79,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.76,135.67v35.83s21.45,0,21.45,0c0-13.13,10.64-23.77,23.77-23.77s23.77,10.64,23.77,23.77h21.45s0-93.97,0-93.97h-38.21c-3.77,0-7.39,1.5-10.06,4.17l-33.84,33.84c-5.34,5.34-8.34,12.58-8.34,20.12Zm29.08-25.24l23.31-24.27h29.44v32.65s-49.36-.36-49.36-.36c-4.16-.03-6.26-5.02-3.38-8.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.58,
    y1: 130.28,
    x2: 146.15,
    y2: 130.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.77,189c-9.65,0-17.5-7.85-17.5-17.5s7.85-17.5,17.5-17.5,17.5,7.85,17.5,17.5-7.85,17.5-17.5,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.77,155c9.1,0,16.5,7.4,16.5,16.5s-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5,7.4-16.5,16.5-16.5m0-2c-10.22,0-18.5,8.28-18.5,18.5s8.28,18.5,18.5,18.5,18.5-8.28,18.5-18.5-8.28-18.5-18.5-18.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 120.98,
    cy: 171.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.98,155c9.1,0,16.5,7.4,16.5,16.5s-7.4,16.5-16.5,16.5-16.5-7.4-16.5-16.5,7.4-16.5,16.5-16.5m0-2c-10.22,0-18.5,8.28-18.5,18.5s8.28,18.5,18.5,18.5,18.5-8.28,18.5-18.5-8.28-18.5-18.5-18.5h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 330,
    y1: 86.16,
    x2: 301.58,
    y2: 86.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 310.39,
    y1: 97.95,
    x2: 281.97,
    y2: 97.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 323.31,
    y1: 109.74,
    x2: 294.9,
    y2: 109.74
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawn);
export default __webpack_public_path__ + "static/media/withdrawn.4a2fb0bf57dddef673d0b21d5f875606.svg";
export { ForwardRef as ReactComponent };